import { IconButton } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';

const customStylePrimary = {
    color: "#004D99",
    width: 30,
    height: 30,
};

export interface CustomAssignmentLoiIconButtonProps {
  title: string;
  currentLoi?: any;
  onCallBack: (currentLoi?: any) => void;
}

const CustomAssignmentLoiIconButton = ({title, onCallBack, currentLoi}: CustomAssignmentLoiIconButtonProps) => {



    return<div className="d-inline w-25">
        <IconButton aria-label="modify" style={customStylePrimary} title={title} onClick={() => onCallBack(currentLoi)}>
            <PersonIcon/>
        </IconButton>
    </div>
}

export default CustomAssignmentLoiIconButton;
